if (!customElements.get('advanced-tab-section')) {
  customElements.define(
    'advanced-tab-section',
    class advancedTabSection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const tabButtons = this.querySelectorAll('.section-btn');
        const tabContents = this.querySelectorAll('[data-tab-content]');

        // When the component loads, show the first tab content
        if (tabContents.length > 0) {
          tabContents.forEach((content, index) => {
            content.style.display = index === 0 ? 'block' : 'none';
          });

          // Set initial button classes
          tabButtons.forEach((b, index) => {
            if (index === 0) {
              b.classList.add('active');
              b.classList.add('button');
              b.classList.remove('button-secondary');
            } else {
              b.classList.remove('active');
              b.classList.remove('button');
              b.classList.add('button-secondary');
            }
          });
        }

        tabButtons.forEach((btn) => {
          btn.addEventListener('click', () => {
            const targetId = btn.getAttribute('data-section');

            // Remove active class and add button-secondary to all buttons
            tabButtons.forEach((b) => {
              b.classList.remove('active');
              b.classList.remove('button');
              b.classList.add('button-secondary');
            });

            // ✅ Fixed line below
            btn.classList.add('active');
            btn.classList.add('button');
            btn.classList.remove('button-secondary');

            // Hide all contents
            tabContents.forEach((content) => {
              if (content.getAttribute('data-tab-content') === targetId) {
                content.style.display = 'block';
              } else {
                content.style.display = 'none';
              }
            });
          });
        });
      }

      disconnectedCallback() {
        // Optional: Cleanup event listeners if needed
      }
    }
  );
}
